export default "__VITE_ASSET__BdWUzoKc__"